import React from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { practiceHubTabsData } from "../../../data/SidebarData";
import Tabs from "../../../Components/Common/Tabs";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";

const PracticeHubIndex = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={practiceHubTabsData} />
      <StaticPageForm
        title="Practice Hub"
        category="civil"
        subscription
        promo
        // typeData={data}
        // type="materials"
        // filter="subscription"
        // subscription
      />
    </div>
  );
};

export default PracticeHubIndex;
